// src/constants/tabDescriptions.ts
// Centralized tab descriptions - update here to change all locations automatically
// Used by: PageHeader (sub-headers), Dashboard cards, Home/Login features

export interface TabDescription {
  id: string;
  label: string;
  icon: string;
  path: string;
  description: string;
}

export const TAB_DESCRIPTIONS: Record<string, TabDescription> = {
  dashboard: {
    id: "dashboard",
    label: "Dashboard",
    icon: "📊",
    path: "/dashboard",
    description: "Your central hub • Select an option below to get started",
  },
  play: {
    id: "play",
    label: "Play",
    icon: "🎮",
    path: "/play-online",
    description: "Play chess online with friends, against AI opponents, or practice locally • Multiple board sizes and variants available",
  },
  multiplayer: {
    id: "multiplayer",
    label: "Multiplayer",
    icon: "🌐",
    path: "/multiplayer",
    description: "Create games, host matches, join games, and challenge with others online",
  },
  pieces: {
    id: "pieces",
    label: "Piece Catalog",
    icon: "📚",
    path: "/piece-catalog",
    description: "Explore 36 unique pieces across 6 classes • View values and movement patterns",
  },
  variants: {
    id: "variants",
    label: "Variant Creator",
    icon: "🎨",
    path: "/variant-creator",
    description: "Design and save your own custom chess variants",
  },
  aiSettings: {
    id: "aiSettings",
    label: "AI Settings",
    icon: "🤖",
    path: "/ai-settings",
    description: "Configure AI opponent difficulty, behavior, and playing style",
  },
  leaderboard: {
    id: "leaderboard",
    label: "Leaderboard",
    icon: "🏆",
    path: "/leaderboard",
    description: "See all players ratings and rankings across all Expanded Chess variants",
  },
  profile: {
    id: "profile",
    label: "My Profile",
    icon: "👤",
    path: "/profile",
    description: "View your account details, membership rewards, stats and game history",
  },
  documents: {
    id: "documents",
    label: "Documents",
    icon: "📄",
    path: "/documents",
    description: "Download Expanded Chess Manual with detailed explanation of Expanded Chess",
  },
  help: {
    id: "help",
    label: "Help",
    icon: "❓",
    path: "/help",
    description: "Find answers, privacy policy, terms of service, and ways to contact Expanded Chess",
  },
};

// Helper function to get description by tab id
export const getTabDescription = (tabId: string): string => {
  return TAB_DESCRIPTIONS[tabId]?.description || "";
};

// Helper function to get tab info by id
export const getTabInfo = (tabId: string): TabDescription | undefined => {
  return TAB_DESCRIPTIONS[tabId];
};

// Export as array for iteration (e.g., in Dashboard cards, Home features)
export const TAB_LIST = Object.values(TAB_DESCRIPTIONS);

// Get tabs for Dashboard cards (excludes Dashboard itself)
export const getDashboardTabs = (): TabDescription[] => {
  return TAB_LIST.filter(tab => tab.id !== "dashboard");
};

export default TAB_DESCRIPTIONS;
